import { DefaultButton } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";
import "./DisplayLocation.css";
import LocationIcon from "assets/svg/location-icon";
import { useHistory } from "react-router-dom";
import { useLocationQuery } from "@graphql";

export interface Props {
  idLocation: string;
}

const DisplayLocation: FunctionComponent<Props> = (props: Props) => {
  const { idLocation } = props;
  const { data: userLocation, loading } = useLocationQuery({ variables: { locationId: idLocation } });
  const history = useHistory();
  const changeLocation = () => {
    const prevUrlPath = history.location.pathname.replace(`/${idLocation}`, "");
    history.push({ pathname: `/selectLocation/${idLocation}`, state: { prevUrlPath: prevUrlPath } });
  };

  return (
    <>
      <div>
        <div className="left-div">
          <LocationIcon></LocationIcon>
        </div>
        <div className="location-name">{userLocation?.location?.name}</div>
        <div className="right-div">
          <DefaultButton toggle text="Change" onClick={() => changeLocation()} className="change-location-btn" />
        </div>
      </div>
    </>
  );
};

export default DisplayLocation;
